import type { PeriodValue as LumenPeriodValue } from '@shinetools/lumen-react'
import { z } from 'zod'

export const ACCOUNT_STATEMENT_FORMATS = ['pdf', 'html', 'csv', 'xlsx'] as const

export const DEFAULT_PERIOD: LumenPeriodValue = { end: null, mode: 'custom', start: null }

// An empty period exports the whole statement, so the period has nothing to validate.
export const getSupplierStatementExportFormSchema = () =>
  z.object({
    format: z.enum(ACCOUNT_STATEMENT_FORMATS),
    period: z.custom<LumenPeriodValue>(),
  })

export type SupplierStatementExportFormSchema = ReturnType<typeof getSupplierStatementExportFormSchema>
export type SupplierStatementExportFormValues = z.infer<SupplierStatementExportFormSchema>

export const getSupplierStatementExportFormDefaultValues = (): SupplierStatementExportFormValues => ({
  format: 'xlsx',
  period: DEFAULT_PERIOD,
})
